export default __webpack_public_path__ + "static/media/Comentarios-orange.8c863dba.svg";